<template>
  <v-app class="app">
    <div class="flex-row">
      <div class="float-left pt-3 pl-3" align="left">
        <v-img
          v-show="showCompactLogo()"
          src="@/assets/img/company-logo/TFF_Silhouette.png"
          alt="Terry Fox Foundation logo"
          contain
          height="50"
          width="50"
        ></v-img>
      </div>

      <div class="float-right pt-3 pr-3" align="right">
        <v-btn
          class="btn-text"
          fab
          small
          outlined
          @click="switchLocale($i18n.locale)"
        >
          {{ $i18n.locale == "en" ? "fr" : "en" }}
        </v-btn>
      </div>
    </div>

    <v-main>
      <v-container class="fill-height">
        <v-col no-gutters>
          <v-img
            v-show="showFullLogo()"
            src="@/assets/img/company-logo/TFF_StackedLogo_BIL.png"
            alt="Terry Fox Foundation logo"
            contain
            height="100"
          ></v-img>

          <router-view />
        </v-col>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "App",
  data: () => ({}),
  methods: {
    switchLocale(locale) {
      if (locale == "en") {
        this.$i18n.locale = "fr";
      } else if (locale == "fr") {
        this.$i18n.locale = "en";
      }
    },
    showCompactLogo() {
      if (
        window.location.pathname == "/" ||
        window.location.pathname == "/home"
      ) {
        return false;
      }

      return true;
    },
    showFullLogo() {
      if (
        window.location.pathname == "/" ||
        window.location.pathname == "/home"
      ) {
        return true;
      }

      return false;
    },
  },
};
</script>

<style lang="scss">
@font-face {
  font-family: "Gibson";
  src: local("Gibson"),
    url("../assets/fonts/Gibson-Regular.ttf") format("truetype");
}

#app {
  font-family: "Gibson", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
